// react
import React, { useEffect } from 'react';
import Routes from './routes.jsx';
import { Icon } from '@shakkerai/components';
import Cookie from 'js-cookie';
import { config } from '@shakkerai/config';

// mantine
import { MantineProvider, createTheme, Select } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';

// css
import './index.scss';

const isPic = config?.env !== 'aws';

const mantineTheme = createTheme({
  colors: {
    primary: Array.from({ length: 10 }).fill(isPic ? '#37a9ff' : '#2EE8C7'),
  },
  cursorType: 'pointer',
  primaryColor: 'primary',
  components: {
    Select: Select.extend({
      defaultProps: {
        allowDeselect: false,
        variant: 'filled',
        checkIconPosition: 'right',
        rightSection: (
          <Icon
            color="var(--color-caption-300)"
            className="select-chevron icon-border_down transition-transform"
            fontSize={14}
          />
        ),
      },
    }),
  },
});

const defaultModalProps = { centered: true };

const ProToolView = () => {
  useEffect(() => {
    const sourceId = new URLSearchParams(window.location.search).get('sourceId'); // 引流的id
    if (sourceId && typeof sourceId === 'string') Cookie.set('attractSourceId', sourceId);
  }, []);
  return (
    <MantineProvider forceColorScheme="light" theme={mantineTheme}>
      <ModalsProvider modalProps={defaultModalProps}>
        <Routes />
      </ModalsProvider>
      <Notifications limit={1} position="top-center" transitionDuration={500} autoClose={3000} zIndex={1100} />
    </MantineProvider>
  );
};

export default ProToolView;
